import type { RouteRecordRaw } from 'vue-router';
import authenticationRoutes from '@/services/authentication/routes/authentication';
import pipelineRoutes from '@/lead/pipeline/routes/pipeline';
import teamRoutes from '@/company/team/routes/team';
import brandRoutes from '@/company/brand/routes/brand';
import userRoutes from '@/company/user/routes/user';
import flowRoutes from '@/flow/flow/routes/flow';
import executionRoutes from '@/flow/execution/routes/execution';
import contactRoutes from '@/lead/contact/routes/contact';
import leadRoutes from '@/lead/lead/routes/lead';
import assistentRoutes from '@/ai/assistent/routes/assistent';
import licenseRoutes from '@/license/routes/license';

const routes: RouteRecordRaw[] = [
    {
        path: '/',
        redirect: { name: 'assistent-dashboard' },
    },
    ...authenticationRoutes,
    ...pipelineRoutes,
    ...teamRoutes,
    ...brandRoutes,
    ...userRoutes,
    ...flowRoutes,
    ...executionRoutes,
    ...leadRoutes,
    ...contactRoutes,
    ...assistentRoutes,
    ...licenseRoutes,
];

export default routes;
